// public-site/src/screens/SignIn.js
// Passwordless sign-in: Case Number + decedent's last name + responsible
// party's last name. On success stores the case-scoped token and continues.

import React, { useState } from 'react';
import { login, setToken } from '../api';
import { styles, colors } from '../theme';
import Brand from '../components/Brand';

export default function SignIn({ onSignedIn }) {
  const [caseNumber, setCaseNumber] = useState('');
  const [decedentLastName, setDecedentLastName] = useState('');
  const [responsiblePartyLastName, setResponsiblePartyLastName] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const canSubmit =
    caseNumber.trim() && decedentLastName.trim() && responsiblePartyLastName.trim() && !busy;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!canSubmit) return;
    setError('');
    setBusy(true);
    try {
      const result = await login({
        caseNumber: caseNumber.trim(),
        decedentLastName: decedentLastName.trim(),
        responsiblePartyLastName: responsiblePartyLastName.trim(),
      });
      setToken(result.token);
      onSignedIn(result.case || null);
    } catch (err) {
      setError(err.message);
      setBusy(false);
    }
  };

  return (
    <div style={styles.page}>
      <form style={styles.card} onSubmit={handleSubmit}>
        <Brand />

        <h1 style={styles.title}>Sign in</h1>
        <p style={styles.bodyText}>Make a payment online</p>

        {error && <div style={styles.errorBox}>{error}</div>}

        <label style={styles.label} htmlFor="caseNumber">Case Number</label>
        <input
          id="caseNumber"
          style={styles.input}
          type="text"
          inputMode="text"
          autoComplete="off"
          placeholder="FC-2026-0001"
          value={caseNumber}
          onChange={(e) => setCaseNumber(e.target.value)}
        />

        <label style={styles.label} htmlFor="decedentLastName">Decedent's last name</label>
        <input
          id="decedentLastName"
          style={styles.input}
          type="text"
          autoComplete="off"
          value={decedentLastName}
          onChange={(e) => setDecedentLastName(e.target.value)}
        />

        <label style={styles.label} htmlFor="rpLastName">Your last name</label>
        <input
          id="rpLastName"
          style={styles.input}
          type="text"
          autoComplete="off"
          value={responsiblePartyLastName}
          onChange={(e) => setResponsiblePartyLastName(e.target.value)}
        />

        <button
          type="submit"
          disabled={!canSubmit}
          style={{ ...styles.buttonPrimary, marginTop: '6px' }}
        >
          {busy ? 'Checking…' : 'Continue'}
        </button>

        <p style={{ ...styles.bodyText, fontSize: '16px', color: colors.textMuted, margin: '20px 0 0', textAlign: 'center' }}>
          Need help? Call 870-367-2451, we'll be happy to assist.
        </p>
      </form>
    </div>
  );
}
